$(".js-load-more").on("click", function () {
  jQuery(this).attr('data-load',true);
  var __this = $(this),
    totalPages = parseInt($('[data-all-pages]').val()),
    currentPage = parseInt($("[data-this-page]").val()),
    datacollurl = $("[data-coll-url]").val();
  __this.attr("disabled", true);
  __this.find("[load-more-text]").addClass("hide");
  __this.find("[loader]").removeClass("hide");
  
  var nextUrl = $('.next_url').attr('value');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;
  //alert(current_page_new);
  //return false;
  $.ajax({
    url: nextUrl,
    type: "GET",
    dataType: "html",
    success: function (responseHTML) {
      
      $("[data-next-url]").val(datacollurl + "?page=" + next_coll);
      $("[data-this-page]").val(current_page_new);
       
      var productsHtml = $(responseHTML).find('.collection_product-grid li'); 
      $(".collection_product-grid").append(productsHtml);
    },
    complete: function () {
      if (current_page_new < totalPages) {
        __this.attr("disabled", false);
        __this.find("[load-more-text]").removeClass("hide");
        __this.find("[loader]").addClass("hide");
      }
      if (current_page_new >= totalPages) {
        __this.find("[load-more-text]").text("Products Finished").removeClass("hide");
        __this.find("[loader]").addClass("hide");
        
      }
    },
  });
});